import { useQuery } from 'react-query';

import { NOTEBOOK_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';
import { QUERY_KEY } from '@/features/ManageTags/common';
import type { Notebook } from '@/features/Notes/types';
import { useGetSearchId } from '@/hooks/useGetSearchId';

export type UseFeedNotebooksResponse = {
  results: Notebook[];
};

export const useFeedNotebooks = () => {
  const { board_id: feedId, channel_id: channelId } = useGetSearchId();
  return useQuery(
    [QUERY_KEY, feedId, channelId],
    ({ signal }) =>
      axiosInstance.get<UseFeedNotebooksResponse>(NOTEBOOK_API_ROUTES.list(), {
        params: { feedId, channelId },
        signal,
      }),
    {
      select: (data) => data.data.results,
    }
  );
};
